import { Pipe, PipeTransform } from '@angular/core';

import { ShSelectableFacetValue } from '../entities/facet.entity';

@Pipe({ standalone: true, name: 'FacetValueLabel' })
export class ShFacetValueLabelPipe implements PipeTransform {
    transform(facetValue: ShSelectableFacetValue, facetLabel: string, noValue: string, noValueKey: string): string {
        if (facetValue.missing) {
            return noValue === noValueKey ? facetValue.label : `${noValue} ${facetLabel}`;
        }
        return facetValue.label;
    }
}
